import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import {
  parseGETParams,
  setToLocalStorage,
  getFromLocalStorage,
  exposeComponentToGlobalScope, prefixPrevProps,
} from '../../utils/utilsGlobal';

import {
  DEFAULT_ISSUE_LIST_FILTERS,
  IssueDetails,
  IssueList,
} from '../../components';

import styles from './PageIssues.scss';

const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
  };
};

@connect(mapStateToProps)
export class PageIssues extends Component {

  state = {
    isLoading: true,
    isFullScreenPreviewOpen: false,
    issueId: null,
    filters: {},
  };

  componentDidMount(){
    this.onUrlParamsChange();
    exposeComponentToGlobalScope(this);
  }

  componentDidUpdate(prevProps){
    const { match, location } = this.props;
    const { prevMatch, prevLocation } = prefixPrevProps(prevProps);

    if (match.params.issueId !== prevMatch.params.issueId || location.search !== prevLocation.search) {
      this.onUrlParamsChange();
    }
  }

  onUrlParamsChange = () => {
    const { match, location } = this.props;
    const { issueId } = match.params;

    if (issueId) {
      this.setState({ issueId, filters: {}, isLoading: false });
    }
    else {
      const urlFilters = parseGETParams(location.search) || {};
      const locallySavedFilters = getFromLocalStorage('ISSUES_FILTERS', {});
      const filters = isEmpty(urlFilters) ? locallySavedFilters : urlFilters;

      this.setState({ issueId: null, filters, isLoading: false });
      if (!isEmpty(filters)) {
        this.setFilterUrlParams(filters);
        setToLocalStorage('ISSUES_FILTERS', filters);
      }
    }
  };

  setFilterUrlParams = (filters) => {
    let queryString = [];
    for (let key in filters) {
      if (filters[key] && filters[key] !== DEFAULT_ISSUE_LIST_FILTERS[key]) {
        queryString.push(`${key}=${filters[key]}`);
      }
    }
    if (queryString.length) {
      queryString = '?' + queryString.join('&');
    }
    history.replaceState({}, null, location.pathname + queryString);
  };

  onFiltersChange = (filtersDiff) => {
    const { filters } = this.state;
    const updatedFilters = { ...filters, ...filtersDiff };
    this.setFilterUrlParams(updatedFilters);
    setToLocalStorage('ISSUES_FILTERS', updatedFilters);
    this.setState({ filters: updatedFilters });
  };

  render(){
    const { className } = this.props;
    const { issueId, filters, isLoading, isFullScreenPreviewOpen } = this.state;

    if (isLoading) {
      return null;
    }

    return (
      <div className={cn({
        [className]: true,
        [styles.container]: true,
        [styles.containerOverlap]: isFullScreenPreviewOpen,
      })}>
        {Boolean(issueId) && (
          <IssueDetails
            issueId={issueId}
            onToggleFullScreenPreview={(isFullScreenPreviewOpen) => { this.setState({ isFullScreenPreviewOpen }) }}/>
        )}
        {!Boolean(issueId) && (
          <IssueList filters={filters} onFiltersChange={this.onFiltersChange}/>
        )}
      </div>
    );
  }
}
